import {
	CurrencyType,
	DiscountTargetType,
	DiscountTermType,
	DiscountType,
	SaleTypeForPlan,
	SaleTypeForTerm,
} from "@/lib/gql/__generated__/graphql";

import type { DiscountOrdinaryInputZodSchemaType as InputModel } from "../validation-schema";

/**
 * InputModel の初期値を生成
 * @param hotelID
 * @returns {InputModel}
 */
export const discountOrdinaryInputModelFactory = (hotelID: string): InputModel => {
	return {
		hotelID,
		discountID: "",
		// 基本設定
		// 公開・非公開
		inSale: false,
		// ディスカウントの名前
		name: "",
		// ディスカウントの説明
		description: "",
		// ディスカウントのコード
		discountCode: "",
		// ディスカウント金額
		discountType: DiscountType.Ratio,
		ratio: 10,
		// ディスカウント対象
		staticTargetType: DiscountTargetType.PerGroup,
		// ディスカウント対象
		staticTermType: DiscountTermType.PerReservation,
		// 最低提供価格
		resourceLowestPrice: {
			amount: 1000,
			currencyType: CurrencyType.Jpy,
		},
		// ディスカウント対象
		isPlanDiscountEligible: true,
		// ディスカウント対象
		isRoomDiscountEligible: true,
		// ディスカウント対象
		isOptionDiscountEligible: true,
		// ディスカウント対象
		isAdditionalFeeDiscountEligible: true,

		// 追加設定
		// キャンセル不可にするか
		isUncancelable: false,
		// 販売タイプ
		saleTypeForPlan: SaleTypeForPlan.Limited,
		// 利用可能期間
		saleTypeForTerm: SaleTypeForTerm.Always,

	} satisfies InputModel;
};
